export const DEFAULT_API_BASE_URL = '/app/api/v1'

export const API_BASE_URL = (import.meta.env.VITE_BASE_URL ?? '').trim() || DEFAULT_API_BASE_URL

export const PUBLIC_API_BASE_URL = API_BASE_URL.startsWith('http')
  ? new URL('/public/api/v1', API_BASE_URL).toString()
  : '/public/api/v1'
